import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { CashAdvanceService } from '../../../../core/api/cash-advance.service';
import { TagService } from '../../../../core/api/tag.service';
import { FileService } from '../../../../core/api/file.service';
import { HelpersService } from '../../../../core/services/helpers.service';
import { AuthService } from '../../../../core/services/auth.service';
import { LoadingService } from '../../../../core/services/loading.service';
import { ConfirmApprovalComponent } from '../../cash-advance-approval/confirm-approval/confirm-approval.component';
import { DetailApprovalDialogComponent } from '../../cash-advance-approval/action-cash-advance-approval/detail-approval-dialog/detail-approval-dialog.component';
import { CashAdvanceApprovalService } from '../../../../core/api/cash-advance-approval.service';
import { CashAdvanceLogService } from '../../../../core/api/cash-advance-log.service';
import { PaymentMethodComponent } from '../payment-method/payment-method.component';
import { ActionSettlementComponent } from '../../cash-advance-approval/action-settlement/action-settlement.component';
import { ProfileDialogComponent } from '../../../../components/profile-dialog/profile-dialog.component';
import { FilePreviewComponent } from '../../../../components/file-preview/file-preview.component';
import moment from 'moment/moment';

@Component({
  selector: 'app-action-cash-advance-finance',
  standalone: true,
  imports: [CommonModule, MatTableModule],
  templateUrl: './action-cash-advance-finance.component.html',
  styleUrl: './action-cash-advance-finance.component.scss',
})
export class ActionCashAdvanceFinanceComponent {
  displayedColumns: string[] = [
    'user',
    'team',
    'sequence',
    'date',
    'status',
    'notes',
    'action',
  ];
  displayedSettlementColumn: string[] = [
    'refId',
    'description',
    'date',
    'location',
    'amount',
    'notes',
    'action',
  ];
  cashAdvance: any = null;
  cashAdvanceLogs: any[] = [];
  tag: any[] = [];
  approvalList: any[] = [];
  latestApproval: any = null;
  currentApproval: any = null;
  id: any;
  m: string;
  currentUser: any;
  settlementData: any[] = [];
  currentStatus: string;

  constructor(
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private cashAdvanceService: CashAdvanceService,
    private cashAdvanceLogService: CashAdvanceLogService,
    private cashAdvanceApprovalService: CashAdvanceApprovalService,
    private tagService: TagService,
    private fileService: FileService,
    private helpers: HelpersService,
    private authService: AuthService,
    private loadingService: LoadingService
  ) {
    this.id = this.activatedRoute.snapshot.queryParams['id'];
    this.m = this.activatedRoute.snapshot.queryParams['m'];
    this.currentUser = this.authService.getLoggedUser();
    this.getCashAdvance();
    this.getTag();
  }

  getCashAdvance() {
    this.loadingService.startLoading();
    this.cashAdvanceService.getApprovalById(this.id).then(
      (resp: any) => {
        this.loadingService.endLoading();
        this.cashAdvance = resp.cashAdvanceData;
        this.currentStatus = this.cashAdvance.status;
        this.settlementData = (resp.settlementData ?? []).map((item: any) => ({
          ...item,
          desciption: item.desciption ?? item.description,
          tagId: item.tagId ?? item.tag?.id,
        }));
        this.sortSettlementData();
        this.getCashAdvanceLog(this.cashAdvance.id);
        this.getApprovalList(this.cashAdvance.id);
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getCashAdvanceLog(cashAdvanceId: any) {
    this.loadingService.startLoading();
    this.cashAdvanceLogService.getCashAdvanceLog(cashAdvanceId).then(
      (resp: any) => {
        this.loadingService.endLoading();
        this.cashAdvanceLogs = resp.map((item: any) => ({
          ...item,
          updated_at: this.toLogDate(item.updated_at),
          created_at: this.toLogDate(item.created_at),
        }));
        this.cashAdvanceLogs.forEach((item: any) => {
          this.getImageUrl(item.creator);
        });
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getTag() {
    this.loadingService.startLoading();
    this.tagService.getAllData().then(
      (res) => {
        this.loadingService.endLoading();
        this.tag = res;
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getApprovalList(cashAdvanceId: any) {
    this.loadingService.startLoading();
    this.cashAdvanceService.getApprovalList(cashAdvanceId).then(
      (resp: any) => {
        this.loadingService.endLoading();
        this.approvalList = resp.filter((item: any) => item.approve_at != null);
        this.currentApproval = resp.find((item: any) => item.isActive);
        if (this.approvalList.length) {
          this.latestApproval =
            this.approvalList[this.approvalList.length - 1].approval_note;
        }
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  private getImageUrl(item: any) {
    if (item.file) {
      this.loadingService.startLoading();
      this.fileService.download(item.file?.id).subscribe(
        (res) => {
          this.loadingService.endLoading();
          item['imageUrl'] = URL.createObjectURL(res);
        },
        (error) => {
          this.loadingService.endLoading();
          this.helpers.sbError(error.message);
        }
      );
    } else {
      item['imageUrl'] = null;
    }
  }

  download() {
    const files = this.getFileItems(this.cashAdvance);
    if (files.length) {
      if (files.length === 1) {
        this.openFile(files[0]);
        return;
      }

      files.forEach((item: any) => this.openFileInNewTab(item));
    } else {
      this.helpers.sbError('Tidak ada file yang bisa diunduh');
    }
  }

  openFile(file: any) {
    if (file) {
      const isMobile = window.innerWidth < 768;
      const canPreviewInline = this.helpers.canPreviewInline(file);

      if (isMobile || !canPreviewInline) {
        this.openFileInNewTab(file);
        return;
      }

      this.dialog
        .open(FilePreviewComponent, {
          width: '70vw',
          maxWidth: '70vw',
          maxHeight: '95vh',
          data: { file },
        })
        .afterClosed()
        .subscribe((item) => {
          if (item) {
          }
        });
    }
  }

  private openFileInNewTab(file: any) {
    this.loadingService.startLoading();
    this.fileService.download(file?.id).subscribe(
      (res) => {
        this.loadingService.endLoading();
        this.helpers.openBlobInNewTab(res, file);
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getFileItems(element: any): any[] {
    return this.helpers.normalizeFileItems(element);
  }

  private sortSettlementData() {
    this.settlementData = [...this.settlementData].sort((a: any, b: any) => {
      const aTime = new Date(
        a?.settlementDate ?? a?.created_at ?? a?.updated_at ?? 0
      ).getTime();
      const bTime = new Date(
        b?.settlementDate ?? b?.created_at ?? b?.updated_at ?? 0
      ).getTime();
      return bTime - aTime;
    });
  }

  approve(): void {
    this.dialog
      .open(ConfirmApprovalComponent, {
        width: '500px',
        maxHeight: '95vh',
        data: {
          expenseCategory: this.cashAdvance?.expenseCategory
        }
      })
      .afterClosed()
      .subscribe((item) => {
        if (item) {
          if (this.cashAdvance.status == 'Settlement Sent To Finance') {
            const payload = item;
            payload['refId'] = this.cashAdvance.refId;
            this.loadingService.startLoading();
            this.cashAdvanceApprovalService
              .approveFinance(payload)
              .then((resp: any) => {
                if (resp.success) {
                  this.loadingService.endLoading();
                  this.helpers.sbSuccess('Cash advance approved!');
                  this.getCashAdvance();
                } else {
                  this.helpers.sbError(resp.message);
                  this.loadingService.endLoading();
                }
              })
              .catch((err: any) => {
                this.loadingService.endLoading();
                this.helpers.sbError(err.message);
              });
          } else {
            this.dialog
              .open(PaymentMethodComponent, {
                width: '500px',
                maxHeight: '95vh',
                data: {
                  bankAccount: {
                    name: this.cashAdvance?.creator?.bankAccountName,
                    bank: this.cashAdvance?.creator?.bankName,
                    number: this.cashAdvance?.creator?.bankAccountNumber,
                  },
                },
              })
              .afterClosed()
              .subscribe((paymentMethodResult) => {
                if (paymentMethodResult) {
                  const payload = item;
                  payload['refId'] = this.cashAdvance.refId;
                  this.loadingService.startLoading();
                  this.cashAdvanceApprovalService
                    .approveFinance(payload)
                    .then((resp: any) => {
                      if (resp.success) {
                        this.loadingService.endLoading();
                        this.helpers.sbSuccess('Cash advance approved!');
                        this.getCashAdvance();
                      } else {
                        this.helpers.sbError(resp.message);
                        this.loadingService.endLoading();
                      }
                    })
                    .catch((err: any) => {
                      this.loadingService.endLoading();
                      this.helpers.sbError(err.message);
                    });
                }
              });
          }
        }
      });
  }

  reject(): void {
    this.dialog
      .open(ConfirmApprovalComponent, {
        width: '500px',
        maxHeight: '95vh',
        data: {
          expenseCategory: this.cashAdvance?.expenseCategory
        }
      })
      .afterClosed()
      .subscribe((item) => {
        if (item) {
          const payload = item;
          payload['refId'] = this.cashAdvance.refId;
          this.loadingService.startLoading();
          this.cashAdvanceApprovalService
            .rejectFinance(payload)
            .then((resp: any) => {
              if (resp.success || resp.susuccess) {
                this.helpers.sbSuccess('Cash advance rejected!');
              } else {
                this.helpers.sbError(resp.message);
              }
              this.getCashAdvance();
            })
            .catch((err: any) => {
              this.loadingService.endLoading();
              this.helpers.sbError(err.message);
            });
        }
      });
  }

  detail(data: any, sequence: any): void {
    data['sequence'] = sequence;
    this.dialog
      .open(DetailApprovalDialogComponent, {
        width: '700px',
        maxHeight: '95vh',
        data,
      })
      .afterClosed()
      .subscribe((item) => {
        if (item) {
        }
      });
  }

  checkCanApprove() {
    const statusCanApprove = ['Sent To Finance', 'Settlement Sent To Finance'];
    if (this.cashAdvance) {
      const financeAll = this.cashAdvance.expenseCategory.finance_all;
      return (
        statusCanApprove.includes(this.cashAdvance.status) &&
        (financeAll ||
          (!financeAll &&
            this.cashAdvance.expenseCategory.finance_user.id ==
              this.currentUser.id))
      );
    }
    return false;
  }

  checkSettlement(action: boolean) {
    const statusSettlement = [
      'Finance Approve',
      'Settlement Sent',
      'Settlement Sent To Finance',
      'Disbursed',
    ];
    if (action) {
      return (
        (statusSettlement.includes(this.currentStatus) ||
          this.settlementData.length) &&
        this.cashAdvance.created_by == this.currentUser.id &&
        this.currentStatus == 'Finance Approve'
      );
    } else {
      return (
        statusSettlement.includes(this.currentStatus) ||
        this.settlementData.length
      );
    }
  }

  detailSettlement(data: any) {
    this.dialog
      .open(ActionSettlementComponent, {
        minWidth: '1000px',
        maxHeight: '95vh',
        data: {
          cashAdvance: this.cashAdvance,
          settlementData: data,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        console.log(result);
      });
  }

  openProfile(userId: any) {
    this.dialog
      .open(ProfileDialogComponent, {
        maxWidth: '70vw',
        maxHeight: '95vh',
        data: userId,
      })
      .afterClosed()
      .subscribe((item) => {});
  }

  getStatusClass(status?: string | null): string {
    switch (status) {
      case 'Draft':
        return 'status-badge status-badge--draft';
      case 'Sent':
        return 'status-badge status-badge--sent';
      case 'Approved':
        return 'status-badge status-badge--approved';
      case 'Rejected':
      case 'Rejected Finance':
      case 'Settlement Rejected':
        return 'status-badge status-badge--rejected';
      case 'Sent To Finance':
      case 'Settlement Sent':
        return 'status-badge status-badge--finance-pending';
      case 'Finance Approve':
        return 'status-badge status-badge--finance-approved';
      case 'Reimbursed':
      case 'Disbursed':
        return 'status-badge status-badge--disbursed';
      case 'Settlement Verified':
        return 'status-badge status-badge--approved';
      case 'Settlement Sent To Finance':
        return 'status-badge status-badge--finance-pending';
      case 'Closed':
        return 'status-badge status-badge--draft';
      default:
        return 'status-badge status-badge--draft';
    }
  }

  getApprovalStatusClass(status: boolean | null | undefined): string {
    if (status === true) return 'status-badge status-badge--disbursed';
    if (status === false) return 'status-badge status-badge--rejected';
    return 'status-badge status-badge--draft';
  }

  getApprovalStatusLabel(status: boolean | null | undefined): string {
    if (status === true) return 'Approved';
    if (status === false) return 'Rejected';
    return '-';
  }

  isLogRejected(item: any): boolean {
    return !!item.description?.includes('Rejected');
  }

  getLogAccentClass(item: any): string {
    if (this.isLogRejected(item)) return 'timeline-accent--rejected';
    if (item.created_by == this.cashAdvance?.created_by) {
      return 'timeline-accent--creator';
    }
    if (item.creator?.role?.code == 'FIN') return 'timeline-accent--finance';
    return 'timeline-accent--approver';
  }

  getSettlementDate(element: any): Date | string | null {
    return element.settlementDate || element.created_at || element.updated_at || null;
  }

  private toLogDate(value: any): Date | null {
    if (!value) return null;
    const parsed = moment(value);
    return parsed.isValid() ? parsed.toDate() : null;
  }

  getLogTimestamp(item: any): Date | null {
    return this.toLogDate(item.updated_at) ?? this.toLogDate(item.created_at);
  }

  isWaitingLog(item: any): boolean {
    return !!item.description?.includes('Waiting');
  }
}
